// Cookie-consent persistence. We store a single decision (analytics on/off)
// plus a timestamp so the banner can re-prompt after ~6 months, as recommended
// by the Garante's 2021 cookie guidelines.

export type CookieConsent = 'accepted' | 'rejected';

const KEY = 'chatly-cookie-consent';
const TS_KEY = 'chatly-cookie-consent-ts';
const MAX_AGE_MS = 1000 * 60 * 60 * 24 * 182; // ~6 months

/** Event the footer dispatches on window to reopen the preferences banner. */
export const COOKIE_PREFS_EVENT = 'chatly:cookie-prefs';

/** Stored consent, or null when absent or older than ~6 months (re-prompt). */
export const getConsent = (): CookieConsent | null => {
  try {
    const value = window.localStorage.getItem(KEY);
    const ts = Number(window.localStorage.getItem(TS_KEY) || 0);
    if ((value === 'accepted' || value === 'rejected') && Date.now() - ts < MAX_AGE_MS) {
      return value;
    }
  } catch {
    /* localStorage unavailable */
  }
  return null;
};

export const setConsent = (value: CookieConsent): void => {
  try {
    window.localStorage.setItem(KEY, value);
    window.localStorage.setItem(TS_KEY, String(Date.now()));
  } catch {
    /* ignore write failures */
  }
};
